import React from "react";
import styled from "styled-components";
import { Section, Container, Eyebrow, H2, Lead } from "../components/ui";
import PhotoSlot from "../components/PhotoSlot";
import { DownloadLink } from "../components/StoreButtons";
import { BudgetCard, CategoriesCard, GoalsCard, PyramidCard } from "../components/MiniCards";
import { photos } from "../content/photos";

const Rows = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6rem;

  @media screen and (max-width: 48em) {
    gap: 4rem;
  }
`;

// Photo and text swap sides on every other row
const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5rem;
  align-items: center;

  & > :first-child {
    order: ${(props) => (props.$flip ? 2 : 1)};
    justify-self: ${(props) => (props.$flip ? "end" : "start")};
  }

  & > :last-child {
    order: ${(props) => (props.$flip ? 1 : 2)};
  }

  @media screen and (max-width: 64em) {
    gap: 3rem;
  }

  @media screen and (max-width: 48em) {
    display: flex;
    flex-direction: column-reverse;
    gap: 2rem;

    & > :first-child,
    & > :last-child {
      order: 0;
    }
  }
`;

const Text = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  a {
    margin-top: 1.75rem;
  }

  @media screen and (max-width: 48em) {
    align-items: center;
    text-align: center;
  }
`;

const FEATURES = [
  {
    key: "budget",
    eyebrow: "Ton « safe to spend »",
    title: "Découvre ce que tu peux dépenser, l'esprit tranquille.",
    text: "Pas le solde de ton compte. Le vrai chiffre, une fois tes charges payées et ton épargne mise de côté. Tu le regardes le matin, tu sais où tu en es.",
    cta: "Voir mon reste à dépenser",
    card: <BudgetCard />,
  },
  {
    key: "categories",
    eyebrow: "Sans effort",
    title: "Où part ton argent, sans rien saisir.",
    text: "Nea récupère tes opérations et les classe toute seule. Tu corriges une fois, elle retient. Tu vois enfin ce qui bouge vraiment d'un mois sur l'autre.",
    cta: "Classer mes dépenses",
    card: <CategoriesCard />,
  },
  {
    key: "goals",
    eyebrow: "Tes projets",
    title: "Tes objectifs, enfin clairs.",
    text: "Un coussin de sécurité, des vacances, un apport. Tu fixes le montant, Nea te montre où tu en es et ce qu'il reste à mettre de côté pour y arriver.",
    cta: "Créer mon premier objectif",
    card: <GoalsCard />,
  },
  {
    key: "patrimoine",
    eyebrow: "Sur la durée",
    title: "Ton compte courant et tes investissements, dans la même vue.",
    text: "La pyramide patrimoniale montre comment ton argent est réparti : ta sécurité en bas, tes investissements au-dessus. Tu vois ce qui manque à un étage avant de monter au suivant.",
    cta: "Voir ma pyramide",
    card: <PyramidCard />,
  },
];

const Features = () => (
  <Section id="fonctionnalites" style={{ paddingTop: "4rem", paddingBottom: "5rem" }}>
    <Container>
      <Rows>
        {FEATURES.map((feature, index) => {
          const flip = index % 2 === 1;
          return (
            <Row key={feature.key} $flip={flip} data-reveal>
              <PhotoSlot photo={photos[feature.key]} side={flip ? "left" : "right"}>
                {feature.card}
              </PhotoSlot>
              <Text>
                <Eyebrow $color="#0a7a53">{feature.eyebrow}</Eyebrow>
                <H2>{feature.title}</H2>
                <Lead>{feature.text}</Lead>
                <DownloadLink position={feature.key}>{feature.cta}</DownloadLink>
              </Text>
            </Row>
          );
        })}
      </Rows>
    </Container>
  </Section>
);

export default Features;
